import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function OrderSelectModal({ title, onClose, openType, handleOrderClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [originRows, setOriginRows] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    order_name: true,
    order_number: true,
    order_status: false,
    order_status_name: true,
    order_date: false,
    order_partner_name: true,
    outgoing_cnt: false,
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      order_name: true,
      order_number: true,
      order_status: false,
      order_status_name: true,
      order_date: false,
      order_partner_name: true,
      outgoing_cnt: false,
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'order_id', width: 0, headerAlign: 'center' },
        { field: 'order_number', headerName: '수주번호', width: 110, headerAlign: 'center', align:'center' },
        { field: 'order_status', headerName: 'order_status', width: 0, headerAlign: 'center'},
        { field: 'order_status_name', headerName: '수주상태', width: 90, headerAlign: 'center', align:'center' },
        { field: 'order_name', headerName: '수주명', width: 230, headerAlign: 'center', align:'left' },
        { field: 'order_date', headerName: '수주일자', width: 0, headerAlign: 'center', align:'center' },
        { field: 'order_partner_name', headerName: '수주처', width: 250, headerAlign: 'center', align:'left' },
        { field: 'outgoing_cnt', headerName: 'outgoing_cnt', width: 0, headerAlign: 'center'}
    ]);
  }

  const handleView = () => {
    axios.get('/api/p/Order/List',
        {
        params : {
          search: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        var array = response.data.map((item, index) => ({
            id: item.order_id,
            order_number: item.order_number,
            order_status: item.order_status,
            order_status_name: item.order_status_name,
            order_date: item.order_date,
            order_name: item.order_name,
            order_partner_name: item.order_partner_name,
            outgoing_cnt: item.outgoing_cnt,
        }));
        setOriginRows(response.data);
        if(openType === 'Outgoing'){ // 출하에서 해당 모달을 열었을 경우 
          array = array.filter((element) => element.order_status === 'S'); // 수주문 취소건은 안보이게
          //array = array.filter((element) => element.outgoing_cnt === 0); // 이미 참조된 수주건도 안보이게
        }
        setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handleOrderClick 이벤트 만들어 놓아야함.
    let selected_id = params.row.id;
    var selected_row_datas = originRows.filter((item, index) => {
      return typeof item.order_id !== 'undefined' && item.order_id === selected_id;
    });
    handleOrderClick(selected_row_datas);
    onClose?.();
  };

  const handleDelete = () => {
    handleOrderClick({
      id: '',
      order_id: '',
      order_date: '',
      order_number: '',
      order_partner_id: '',
      order_partner_name: '',
      order_partner_manager: '',
      order_partner_manager_phone: '',
      order_partner_manager_mail: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default OrderSelectModal;